import { AnalyticsTimeInterval } from '@sprinklr/stories/analytics/AnalyticsRequest';
import { unitOfTime } from 'moment';

const toMomentUnitOfTime = (
    interval: AnalyticsTimeInterval
): [number, unitOfTime.Base | unitOfTime._quarter] => {
    return [
        parseInt(interval[0], 10),
        interval[1] === 'q' ? interval[1].toUpperCase() : (interval[1] as any),
    ];
};

export default toMomentUnitOfTime;
